import { QueryClient } from '@tanstack/react-query'
import { getDefaultStore } from 'jotai'

const store = getDefaultStore()
const queryClient = new QueryClient()

export { queryClient, store }
